import {ModalV3} from "../helpers/modals/ClassBased/ModalV3";
import {getSingleInputByNameV3} from "../helpers/inputs/forms/fornInputHelpers";
import {clearFeedbacksByName, clearInputsByName, fillInputsByName} from "../helpers/forms";
import {setupFileUploader} from "../common/filesUploader";
import {displayLocalValidationError} from "../helpers/forms/validationErrors/utils";
import {IdeasBoardSelectPostModal} from "../design-board/IdeasBoardSelectPostModal";

// noinspection JSUnusedGlobalSymbols -- Imported via d.ts
class DesignStudioCustomChoiceModal extends ModalV3 {
	/** @var {DesignStudioCustomChoiceModalDefs.Config} */
	config;

	/** @var {DesignStudioCustomChoiceModalDefs.IdeasBoardPost} */
	ideaBoardPost;

	constructor(config) {
		super(config);

		this.config = config;
	}

	init() {
		// Set on success event
		this.modalContainer.querySelector('.confirm-button').addEventListener('click', () => {
			clearFeedbacksByName(this.modalContainer);

			// If no related ideas board was selected...
			if (this.getData().ideas_board_post_id === '') {
				// ... validate text field
				if (this.getData().custom_choice.trim().length === 0) {
					displayLocalValidationError(this.modalContainer, 'custom_choice', 'Please fill in this field');
					return;
				}
			}

			this.notifySuccessListeners();
			this.hide();
		})

		// Set on back event
		$(this.modalContainer).on('hide.bs.modal', () => {
			if (this.config.onBackRequest) {
				// Check for special case
				if (window['__IGNORE_BACK_REQUEST_FOR_CUSTOM_CHOICE_MODAL']) {
					// Ignore callback this one time and delete flag
					delete window['__IGNORE_BACK_REQUEST_FOR_CUSTOM_CHOICE_MODAL'];
					return;
				}
				this.config.onBackRequest();
			}
		})

		// Setup pick from ideas board button
		const pickFromIdeasBoardButton = this.modalContainer.querySelector('.pick-from-ideas-board-button');
		if (pickFromIdeasBoardButton) {
			pickFromIdeasBoardButton.addEventListener(
				'click',
				() => this.handlePickFromIdeasBoardRequest(pickFromIdeasBoardButton.dataset.route)
			);
		}

		// Mark as initialized
		this.modalContainer.classList.add('init');

		let existingFiles = [];

		// Always fill in passed custom choice
		clearInputsByName(this.modalContainer, ['custom_choice', 'ideas_board_post_id']);

		this.ideaBoardPost = null;


		// Hide ideas board reference container
		this.hideIdeasBoardReferenceContainer();

		// Setup remove idea reference button
		const removeReferenceButton = this.modalContainer.querySelector('.remove-idea-board-reference-button');
		if (removeReferenceButton) {
			removeReferenceButton.addEventListener('click', () => {
				this.removeIdeasBoardReference();
			})
		}

		if (this.config.existingCustomChoice) {
			fillInputsByName(this.modalContainer, this.config.existingCustomChoice);

			this.ideaBoardPost = this.config.existingCustomChoice.related_idea_board_post;
			// I am not sure why this is needed...
			setTimeout(() => {
				this.ideaBoardPost = this.config.existingCustomChoice.related_idea_board_post;
			})
			// Retrieve files
			existingFiles = this.config.existingCustomChoice.pictures;

			// Display ideas board reference container
			if (this.ideaBoardPost) {
				this.displayIdeasBoardReferenceContainer();
			}
		}

		// Setup file uploads
		const filesUploadUrl = this.modalContainer.querySelector('input[name="file_uploads_url"]').value;

		// Delete previous file uploader DOM
		const fileUploaderContainer = this.modalContainer.querySelector('.pictures-container');

		// Clean up previous uppy file uploader
		const newFileUploadContainer = fileUploaderContainer.cloneNode(true);

		newFileUploadContainer.innerHTML = '';

		this.picturesFileUploader = setupFileUploader(
			{
				target: fileUploaderContainer,
			},
			filesUploadUrl,
			existingFiles
		)
	}

	/**
	 * @return {DesignStudioCustomChoiceModalDefs.CustomChoice}
	 */
	getData() {
		const pictures = [];

		// Retrieve file uploads
		this.picturesFileUploader.getFiles().forEach(file => {
			if (file.response) {
				// Store uppy file instance returned from server
				// noinspection JSCheckFunctionSignatures
				pictures.push(file.response.body.file)
			} else {
				// Retrieve from existing data
				// noinspection JSCheckFunctionSignatures
				pictures.push(file.meta.serverFileObject);
			}
		})

		return {
			custom_choice: getSingleInputByNameV3(this.modalContainer, 'custom_choice'),
			pictures: pictures,
			ideas_board_post_id: getSingleInputByNameV3(this.modalContainer, 'ideas_board_post_id'),
			related_idea_board_post: this.ideaBoardPost,
		}
	}

	handlePickFromIdeasBoardRequest(modalRoute) {
		// Setup flag to tell current modal to not execute back request callback when hiding
		window['__IGNORE_BACK_REQUEST_FOR_CUSTOM_CHOICE_MODAL'] = true;
		// Hide current modal
		this.hide();

		// Display new modal
		new IdeasBoardSelectPostModal(modalRoute, {
			onBackRequest: () => {
				// Display original modal again
				this.display(false)
			},
			onSuccess: (modal, post) => {
				// Display original modal again
				this.display(false);
				this.handleIdeaBoardPostSelection(post);
			}
		});
	}

	handleIdeaBoardPostSelection(selectedPost) {
		// Set selected post id in form
		fillInputsByName(this.modalContainer, {
			ideas_board_post_id: selectedPost.id,
		})

		// And save in memory
		this.ideaBoardPost = selectedPost;

		this.displayIdeasBoardReferenceContainer();
	}

	displayIdeasBoardReferenceContainer() {
		this.getIdeasBoardReferenceContainer().classList.remove('d-none');
		this.getIdeasBoardReferenceContainer().classList.add('d-flex');

		this.getIdeasBoardReferenceContainer().querySelector('.ideas-board-post-title').innerText = this.ideaBoardPost.title;
		this.getIdeasBoardReferenceContainer().querySelector('.ideas-board-post-image-container img').src = this.ideaBoardPost.public_image_path;
	}

	hideIdeasBoardReferenceContainer() {
		this.getIdeasBoardReferenceContainer().classList.remove('d-flex');
		this.getIdeasBoardReferenceContainer().classList.add('d-none');
	}

	removeIdeasBoardReference() {
		this.ideaBoardPost = null;
		fillInputsByName(this.modalContainer, {
			ideas_board_post_id: '',
		})

		this.hideIdeasBoardReferenceContainer();
	}


	/**
	 * @return {HTMLElement}
	 */
	getIdeasBoardReferenceContainer() {
		return this.modalContainer.querySelector('.ideas-board-reference-container');
	}
}

export {DesignStudioCustomChoiceModal}
